/* 
Author:Lamiaa Moustafa
Desc: Reusable button component 
*/

import React from "react";
 import { Button } from "../../Styles/styledComponents/Buttons";

export const Button1st2911 = (props) => {
  const { label, onClick, className } = props.data;
  return (
    <>
      <Button className={className} backgroundColor = "#ff9b30" onClick={onClick}> {label}</Button>
      
    </>
  );
};
